
import FormComponent from "../../../../components/postcard_rewards/configs/Form.vue";

export default {
  components: {
    FormComponent,
  },
};
